// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AddContextController from "./add_context_controller"
application.register("add-context", AddContextController)

import AiBuildRedirectController from "./ai_build_redirect_controller"
application.register("ai-build-redirect", AiBuildRedirectController)

import AiLoadingAnimationController from "./ai_loading_animation_controller"
application.register("ai-loading-animation", AiLoadingAnimationController)

import AiWizardController from "./ai_wizard_controller"
application.register("ai-wizard", AiWizardController)

import AlertFormController from "./alert_form_controller"
application.register("alert-form", AlertFormController)

import AppModeController from "./app_mode_controller"
application.register("app-mode", AppModeController)

import AutosubmitController from "./autosubmit_controller"
application.register("autosubmit", AutosubmitController)

import AvatarPreviewController from "./avatar_preview_controller"
application.register("avatar-preview", AvatarPreviewController)

import BaggingReviewController from "./bagging_review_controller"
application.register("bagging-review", BaggingReviewController)

import BaggingSectionController from "./bagging_section_controller"
application.register("bagging-section", BaggingSectionController)

import ChatContextSyncController from "./chat_context_sync_controller"
application.register("chat-context-sync", ChatContextSyncController)

import ChatFormController from "./chat_form_controller"
application.register("chat-form", ChatFormController)

import ChatScrollController from "./chat_scroll_controller"
application.register("chat-scroll", ChatScrollController)

import CheckboxVisibilityController from "./checkbox_visibility_controller"
application.register("checkbox-visibility", CheckboxVisibilityController)

import ChipToggleController from "./chip_toggle_controller"
application.register("chip-toggle", ChipToggleController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ColorPickerController from "./color_picker_controller"
application.register("color-picker", ColorPickerController)

import ComboChartController from "./combo_chart_controller"
application.register("combo-chart", ComboChartController)

import ConfettiController from "./confetti_controller"
application.register("confetti", ConfettiController)

import CountUpController from "./count_up_controller"
application.register("count-up", CountUpController)

import CustomFields__AlertWarningController from "./custom_fields/alert_warning_controller"
application.register("custom-fields--alert-warning", CustomFields__AlertWarningController)

import CustomFields__FormFieldsController from "./custom_fields/form_fields_controller"
application.register("custom-fields--form-fields", CustomFields__FormFieldsController)

import CustomFields__FormulaEditorController from "./custom_fields/formula_editor_controller"
application.register("custom-fields--formula-editor", CustomFields__FormulaEditorController)

import CustomFields__ValidationsController from "./custom_fields/validations_controller"
application.register("custom-fields--validations", CustomFields__ValidationsController)

import CustomFormDraftController from "./custom_form_draft_controller"
application.register("custom-form-draft", CustomFormDraftController)

import Dashboard__MapController from "./dashboard/map_controller"
application.register("dashboard--map", Dashboard__MapController)

import Dashboard__PeriodBarController from "./dashboard/period_bar_controller"
application.register("dashboard--period-bar", Dashboard__PeriodBarController)

import DateRangeToggleController from "./date_range_toggle_controller"
application.register("date-range-toggle", DateRangeToggleController)

import DebugPanelController from "./debug_panel_controller"
application.register("debug-panel", DebugPanelController)

import DeleteConfirmationController from "./delete_confirmation_controller"
application.register("delete-confirmation", DeleteConfirmationController)

import DetailChartController from "./detail_chart_controller"
application.register("detail-chart", DetailChartController)

import DismissOnInputController from "./dismiss_on_input_controller"
application.register("dismiss-on-input", DismissOnInputController)

import DownloadSuppliesFormController from "./download_supplies_form_controller"
application.register("download-supplies-form", DownloadSuppliesFormController)

import EfficiencyChartToggleController from "./efficiency_chart_toggle_controller"
application.register("efficiency-chart-toggle", EfficiencyChartToggleController)

import Farms__Users__PermissionsController from "./farms/users/permissions_controller"
application.register("farms--users--permissions", Farms__Users__PermissionsController)

import FieldCycleLineItemModalController from "./field_cycle_line_item_modal_controller"
application.register("field-cycle-line-item-modal", FieldCycleLineItemModalController)

import FieldCycles__ReportMapController from "./field_cycles/report_map_controller"
application.register("field-cycles--report-map", FieldCycles__ReportMapController)

import FieldTaskFormController from "./field_task_form_controller"
application.register("field-task-form", FieldTaskFormController)

import FieldTaskLogModalController from "./field_task_log_modal_controller"
application.register("field-task-log-modal", FieldTaskLogModalController)

import FieldTaskQuickLogController from "./field_task_quick_log_controller"
application.register("field-task-quick-log", FieldTaskQuickLogController)

import FieldTaskUnitRenameController from "./field_task_unit_rename_controller"
application.register("field-task-unit-rename", FieldTaskUnitRenameController)

import FileInputTriggerController from "./file_input_trigger_controller"
application.register("file-input-trigger", FileInputTriggerController)

import FilesDrawerController from "./files_drawer_controller"
application.register("files-drawer", FilesDrawerController)

import FilterToggleController from "./filter_toggle_controller"
application.register("filter-toggle", FilterToggleController)

import GanttChartController from "./gantt_chart_controller"
application.register("gantt-chart", GanttChartController)

import GeneralCostAllocationController from "./general_cost_allocation_controller"
application.register("general-cost-allocation", GeneralCostAllocationController)

import GeneratedCodeController from "./generated_code_controller"
application.register("generated-code", GeneratedCodeController)

import HarvestCycle__FormController from "./harvest_cycle/form_controller"
application.register("harvest-cycle--form", HarvestCycle__FormController)

import HarvestCycleCropPricingController from "./harvest_cycle_crop_pricing_controller"
application.register("harvest-cycle-crop-pricing", HarvestCycleCropPricingController)

import HarvestEntries__FormController from "./harvest_entries/form_controller"
application.register("harvest-entries--form", HarvestEntries__FormController)

import HarvestEntries__SyncController from "./harvest_entries/sync_controller"
application.register("harvest-entries--sync", HarvestEntries__SyncController)

import HarvestEntries__WithoutVehicleFormController from "./harvest_entries/without_vehicle_form_controller"
application.register("harvest-entries--without-vehicle-form", HarvestEntries__WithoutVehicleFormController)

import HarvestPlanModalController from "./harvest_plan_modal_controller"
application.register("harvest-plan-modal", HarvestPlanModalController)

import HarvestScheduleFormController from "./harvest_schedule_form_controller"
application.register("harvest-schedule-form", HarvestScheduleFormController)

import IsoWeekCalendarController from "./iso_week_calendar_controller"
application.register("iso-week-calendar", IsoWeekCalendarController)

import LeftbarScrollController from "./leftbar_scroll_controller"
application.register("leftbar-scroll", LeftbarScrollController)

import LineItemFormController from "./line_item_form_controller"
application.register("line-item-form", LineItemFormController)

import LineItemQuantityHelpersController from "./line_item_quantity_helpers_controller"
application.register("line-item-quantity-helpers", LineItemQuantityHelpersController)

import LineItemRowsController from "./line_item_rows_controller"
application.register("line-item-rows", LineItemRowsController)

import LoadingIndicatorController from "./loading_indicator_controller"
application.register("loading-indicator", LoadingIndicatorController)

import LotActivityCardController from "./lot_activity_card_controller"
application.register("lot-activity-card", LotActivityCardController)

import LotActivityHeatmapController from "./lot_activity_heatmap_controller"
application.register("lot-activity-heatmap", LotActivityHeatmapController)

import LotSelectionCounterController from "./lot_selection_counter_controller"
application.register("lot-selection-counter", LotSelectionCounterController)

import Lots__BulkImportController from "./lots/bulk_import_controller"
application.register("lots--bulk-import", Lots__BulkImportController)

import Lots__BulkImportMappingController from "./lots/bulk_import_mapping_controller"
application.register("lots--bulk-import-mapping", Lots__BulkImportMappingController)

import Lots__FormMapController from "./lots/form_map_controller"
application.register("lots--form-map", Lots__FormMapController)

import Lots__IndexMapController from "./lots/index_map_controller"
application.register("lots--index-map", Lots__IndexMapController)

import Lots__ShowMapController from "./lots/show_map_controller"
application.register("lots--show-map", Lots__ShowMapController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MultiDaySelectController from "./multi_day_select_controller"
application.register("multi-day-select", MultiDaySelectController)

import MultiMonitorChartController from "./multi_monitor_chart_controller"
application.register("multi-monitor-chart", MultiMonitorChartController)

import MultiselectDropdownController from "./multiselect_dropdown_controller"
application.register("multiselect-dropdown", MultiselectDropdownController)

import NavFlyoutController from "./nav_flyout_controller"
application.register("nav-flyout", NavFlyoutController)

import NewAssigneeController from "./new_assignee_controller"
application.register("new-assignee", NewAssigneeController)

import NewFieldTaskController from "./new_field_task_controller"
application.register("new-field-task", NewFieldTaskController)

import NewPersonController from "./new_person_controller"
application.register("new-person", NewPersonController)

import NotesFormController from "./notes_form_controller"
application.register("notes-form", NotesFormController)

import Organizations__FarmsMapController from "./organizations/farms_map_controller"
application.register("organizations--farms-map", Organizations__FarmsMapController)

import PanelResizeController from "./panel_resize_controller"
application.register("panel-resize", PanelResizeController)

import PeriodFilterBarController from "./period_filter_bar_controller"
application.register("period-filter-bar", PeriodFilterBarController)

import PostHarvest__CarryOverReceivedController from "./post_harvest/carry_over_received_controller"
application.register("post-harvest--carry-over-received", PostHarvest__CarryOverReceivedController)

import PostHarvest__ClassificationController from "./post_harvest/classification_controller"
application.register("post-harvest--classification", PostHarvest__ClassificationController)

import PostHarvest__ContainerWeightsController from "./post_harvest/container_weights_controller"
application.register("post-harvest--container-weights", PostHarvest__ContainerWeightsController)

import PostHarvest__DryingAllocationController from "./post_harvest/drying_allocation_controller"
application.register("post-harvest--drying-allocation", PostHarvest__DryingAllocationController)

import PostHarvest__DryingOutputController from "./post_harvest/drying_output_controller"
application.register("post-harvest--drying-output", PostHarvest__DryingOutputController)

import PostHarvest__EvidenceFilesController from "./post_harvest/evidence_files_controller"
application.register("post-harvest--evidence-files", PostHarvest__EvidenceFilesController)

import PostHarvest__HarvestContainersController from "./post_harvest/harvest_containers_controller"
application.register("post-harvest--harvest-containers", PostHarvest__HarvestContainersController)

import PostHarvest__NewContainersController from "./post_harvest/new_containers_controller"
application.register("post-harvest--new-containers", PostHarvest__NewContainersController)

import PostHarvest__PackagingController from "./post_harvest/packaging_controller"
application.register("post-harvest--packaging", PostHarvest__PackagingController)

import PostHarvest__PhotoUploadController from "./post_harvest/photo_upload_controller"
application.register("post-harvest--photo-upload", PostHarvest__PhotoUploadController)

import PostHarvest__QaDecisionController from "./post_harvest/qa_decision_controller"
application.register("post-harvest--qa-decision", PostHarvest__QaDecisionController)

import PostHarvest__QualityInspectionController from "./post_harvest/quality_inspection_controller"
application.register("post-harvest--quality-inspection", PostHarvest__QualityInspectionController)

import PostHarvest__WeightMismatchController from "./post_harvest/weight_mismatch_controller"
application.register("post-harvest--weight-mismatch", PostHarvest__WeightMismatchController)

import PostHarvest__YieldPreviewController from "./post_harvest/yield_preview_controller"
application.register("post-harvest--yield-preview", PostHarvest__YieldPreviewController)

import PostHarvestOperatorImportController from "./post_harvest_operator_import_controller"
application.register("post-harvest-operator-import", PostHarvestOperatorImportController)

import PushDrawerController from "./push_drawer_controller"
application.register("push-drawer", PushDrawerController)

import RebalancingUploadController from "./rebalancing_upload_controller"
application.register("rebalancing-upload", RebalancingUploadController)

import RemovalsController from "./removals_controller"
application.register("removals", RemovalsController)

import RequestController from "./request_controller"
application.register("request", RequestController)

import RibbonSwatchController from "./ribbon_swatch_controller"
application.register("ribbon-swatch", RibbonSwatchController)

import RouteCalendarController from "./route_calendar_controller"
application.register("route-calendar", RouteCalendarController)

import RouteDatapoints__DependencyFieldsController from "./route_datapoints/dependency_fields_controller"
application.register("route-datapoints--dependency-fields", RouteDatapoints__DependencyFieldsController)

import RouteDatapoints__FormController from "./route_datapoints/form_controller"
application.register("route-datapoints--form", RouteDatapoints__FormController)

import RouteExportController from "./route_export_controller"
application.register("route-export", RouteExportController)

import RouteLauncher__IndexController from "./route_launcher/index_controller"
application.register("route-launcher--index", RouteLauncher__IndexController)

import RouteMapReports__FiltersController from "./route_map_reports/filters_controller"
application.register("route-map-reports--filters", RouteMapReports__FiltersController)

import RouteMapReports__MapController from "./route_map_reports/map_controller"
application.register("route-map-reports--map", RouteMapReports__MapController)

import RouteTrees__ShowMapController from "./route_trees/show_map_controller"
application.register("route-trees--show-map", RouteTrees__ShowMapController)

import SanitationFormTemplates__InstallPickerController from "./sanitation_form_templates/install_picker_controller"
application.register("sanitation-form-templates--install-picker", SanitationFormTemplates__InstallPickerController)

import SanitationForms__DownloadController from "./sanitation_forms/download_controller"
application.register("sanitation-forms--download", SanitationForms__DownloadController)

import SanitationForms__FirstStepController from "./sanitation_forms/first_step_controller"
application.register("sanitation-forms--first-step", SanitationForms__FirstStepController)

import SanitationForms__FormComponentController from "./sanitation_forms/form_component_controller"
application.register("sanitation-forms--form-component", SanitationForms__FormComponentController)

import SanitationForms__GpsCalibrationController from "./sanitation_forms/gps_calibration_controller"
application.register("sanitation-forms--gps-calibration", SanitationForms__GpsCalibrationController)

import SanitationForms__OpenEndedCheckpointController from "./sanitation_forms/open_ended_checkpoint_controller"
application.register("sanitation-forms--open-ended-checkpoint", SanitationForms__OpenEndedCheckpointController)

import SanitationForms__OpenEndedSamplesCheckpointController from "./sanitation_forms/open_ended_samples_checkpoint_controller"
application.register("sanitation-forms--open-ended-samples-checkpoint", SanitationForms__OpenEndedSamplesCheckpointController)

import SanitationForms__WizardComponentController from "./sanitation_forms/wizard_component_controller"
application.register("sanitation-forms--wizard-component", SanitationForms__WizardComponentController)

import SanitationReports__ChoiceSwitcherController from "./sanitation_reports/choice_switcher_controller"
application.register("sanitation-reports--choice-switcher", SanitationReports__ChoiceSwitcherController)

import SanitationReports__FiltersController from "./sanitation_reports/filters_controller"
application.register("sanitation-reports--filters", SanitationReports__FiltersController)

import SanitationReports__FocusPeriodChartController from "./sanitation_reports/focus_period_chart_controller"
application.register("sanitation-reports--focus-period-chart", SanitationReports__FocusPeriodChartController)

import SanitationReports__FocusSectionController from "./sanitation_reports/focus_section_controller"
application.register("sanitation-reports--focus-section", SanitationReports__FocusSectionController)

import SanitationReports__MetricSwitcherController from "./sanitation_reports/metric_switcher_controller"
application.register("sanitation-reports--metric-switcher", SanitationReports__MetricSwitcherController)

import SanitationReports__SampleCountChartController from "./sanitation_reports/sample_count_chart_controller"
application.register("sanitation-reports--sample-count-chart", SanitationReports__SampleCountChartController)

import SanitationReports__TableSectionsController from "./sanitation_reports/table_sections_controller"
application.register("sanitation-reports--table-sections", SanitationReports__TableSectionsController)

import SanitationRouteHistoryGuardController from "./sanitation_route_history_guard_controller"
application.register("sanitation-route-history-guard", SanitationRouteHistoryGuardController)

import SanitationRoutes__ShowController from "./sanitation_routes/show_controller"
application.register("sanitation-routes--show", SanitationRoutes__ShowController)

import SanitationRoutes__ShowMapController from "./sanitation_routes/show_map_controller"
application.register("sanitation-routes--show-map", SanitationRoutes__ShowMapController)

import SanitationRoutes__UploadButtonController from "./sanitation_routes/upload_button_controller"
application.register("sanitation-routes--upload-button", SanitationRoutes__UploadButtonController)

import ScrollEndController from "./scroll_end_controller"
application.register("scroll-end", ScrollEndController)

import ScrollPreserveController from "./scroll_preserve_controller"
application.register("scroll-preserve", ScrollPreserveController)

import ScrollToTodayController from "./scroll_to_today_controller"
application.register("scroll-to-today", ScrollToTodayController)

import SelectNavigateController from "./select_navigate_controller"
application.register("select-navigate", SelectNavigateController)

import SimCellController from "./sim_cell_controller"
application.register("sim-cell", SimCellController)

import SimulationConversionPreviewController from "./simulation_conversion_preview_controller"
application.register("simulation-conversion-preview", SimulationConversionPreviewController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import StatementLineItems__FormController from "./statement_line_items/form_controller"
application.register("statement-line-items--form", StatementLineItems__FormController)

import StatementPricingController from "./statement_pricing_controller"
application.register("statement-pricing", StatementPricingController)

import StatementSecondaryPackagingLineItems__FormController from "./statement_secondary_packaging_line_items/form_controller"
application.register("statement-secondary-packaging-line-items--form", StatementSecondaryPackagingLineItems__FormController)

import StorageStatusController from "./storage_status_controller"
application.register("storage-status", StorageStatusController)

import SupplyRowsController from "./supply_rows_controller"
application.register("supply-rows", SupplyRowsController)

import TabController from "./tab_controller"
application.register("tab", TabController)

import TableSortController from "./table_sort_controller"
application.register("table-sort", TableSortController)

import TagInputController from "./tag_input_controller"
application.register("tag-input", TagInputController)

import TagRenameController from "./tag_rename_controller"
application.register("tag-rename", TagRenameController)

import TreePopulationReasonController from "./tree_population_reason_controller"
application.register("tree-population-reason", TreePopulationReasonController)

import TreeTableController from "./tree_table_controller"
application.register("tree-table", TreeTableController)

import Ui__TabsController from "./ui/tabs_controller"
application.register("ui--tabs", Ui__TabsController)
